/**
 * Sprint 1 (garde-fou des e-mails) — « Vérité à l'écran ».
 *
 * Un envoi vers une entreprise (relance des réserves, relance du DOE, demande en GPA)
 * n'est dit « envoyé » que si l'e-mail est réellement parti. Sinon on dit pourquoi.
 * Clés = `email_status` renvoyé par le backend (email_service.statut_envoi).
 */
export const RAISON_NON_ENVOI = {
  sans_adresse: 'aucune adresse e-mail',
  notification_desactivee: 'e-mail désactivé',
  en_file_mode_preparation: "envois d'e-mails en pause",
  echec: "échec d'envoi",
};

export const raisonNonEnvoi = (statut) => RAISON_NON_ENVOI[statut] || RAISON_NON_ENVOI.echec;

/** Libellé de la dernière relance : { texte, envoye }. */
export const libelleRelance = (relance, dateFr) => {
  if (!relance) return null;
  const d = dateFr(relance.le);
  if (relance.email_status === 'envoye') return { texte: `Relancée par e-mail le ${d}`, envoye: true };
  const raison = raisonNonEnvoi(relance.email_status);
  if (relance.notifications > 0) {
    return { texte: `Relancée le ${d} dans l'application · e-mail non envoyé : ${raison}`, envoye: false };
  }
  if (relance.notifications === 0) return { texte: `Relance du ${d} non envoyée : ${raison}`, envoye: false };
  return { texte: `Relance du ${d} · e-mail non envoyé : ${raison}`, envoye: false };
};

/** Toast adapté au résultat d'un envoi ({ email_sent | email_status, ok, message }). */
export const toastEnvoi = (toast, data) => {
  const parti = data.email_sent === true || data.email_status === 'envoye';
  if (parti) toast.success(data.message);
  else if (data.ok) toast.warning(data.message);
  else toast.error(data.message);
};
